module.exports = __webpack_public_path__ + "static/media/7.a93a20bd.png";